import type { Customer, GetCustomerResponse } from "modules/customers";
import type { UUID } from ".";

export const findChildrenIds = (
  customers: Customer[] | GetCustomerResponse[]
): UUID[] => {
  return customers
    .map((customer) => [
      customer.id,
      ...findChildrenIds(customer.children ?? []),
    ])
    .reduce((acc, ids) => {
      acc.push(...ids);

      return acc;
    }, []);
};
